import { render, staticRenderFns } from "./calendarioAsistencia.vue?vue&type=template&id=2302a6ea"
import script from "./calendarioAsistencia.vue?vue&type=script&lang=js"
export * from "./calendarioAsistencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports